(() => {
  const priceSelector = '.product-redesign-price';
  const buyPriceSelector = 'product-buy-price[data-redesign-euro-price]';

  const formatEuroText = (text, spaceBeforeSymbol = false) => {
    const euroSuffix = spaceBeforeSymbol ? ' €' : '€';

    return text
      .replace(/€\s*([\d.,]+)\s*(?:EUR)?/gi, `$1${euroSuffix}`)
      .replace(/([\d.,]+)\s*(?:EUR|€)/gi, `$1${euroSuffix}`);
  };

  const syncPrice = (price) => {
    const source = price.querySelector('.product-redesign-price__source');
    const display = price.querySelector('[data-redesign-price-display]');
    if (!source || !display) return;

    const formattedText = formatEuroText(source.textContent, true).trim();
    if (display.textContent !== formattedText) {
      display.textContent = formattedText;
    }
  };

  const syncBuyPrice = (price) => {
    const formattedText = formatEuroText(price.textContent, true).trim();
    if (price.textContent !== formattedText) {
      price.textContent = formattedText;
    }
  };

  const formatPrices = (root = document) => {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(priceSelector)) {
      syncPrice(root);
    }

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(buyPriceSelector)) {
      syncBuyPrice(root);
    }

    root.querySelectorAll?.(priceSelector).forEach(syncPrice);
    root.querySelectorAll?.(buyPriceSelector).forEach(syncBuyPrice);
  };

  // 移动端粘性表单按钮里的价格后缀 ("In den Warenkorb - 2.419,00 €"):
  // 从同一个 sticky form 的隐藏价格源取文本。变体切换时 StickyPrice 的
  // innerHTML 会被整体替换(不在 .btn-text 内), 这里在每次变动后统一重同步。
  // 售罄(按钮 disabled)/不可用(StickyPrice 被 hidden)时后缀一并隐藏。
  const stickyButtonPriceSelector = '[data-sticky-btn-price]';

  const syncStickyButtonPrices = () => {
    document.querySelectorAll(stickyButtonPriceSelector).forEach((element) => {
      const stickyForm = element.closest('product-sticky-form');
      const source = stickyForm?.querySelector('.product-redesign-price__source');
      const formattedText = source ? formatEuroText(source.textContent, true).trim() : '';
      const shouldHide = !formattedText
        || source?.closest('[hidden]') != null
        || element.closest('button')?.disabled;

      if (!shouldHide) {
        const nextText = ` - ${formattedText}`;
        if (element.textContent !== nextText) element.textContent = nextText;
      }
      element.hidden = shouldHide;
    });
  };

  const startPriceFormatter = () => {
    formatPrices();
    syncStickyButtonPrices();

    let animationFrameId = 0;
    const scheduleFormatPrices = () => {
      if (animationFrameId) return;

      animationFrameId = requestAnimationFrame(() => {
        animationFrameId = 0;
        formatPrices();
        syncStickyButtonPrices();
      });
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const target = mutation.target.nodeType === Node.TEXT_NODE
          ? mutation.target.parentElement
          : mutation.target;

        if (!target) return;

        formatPrices(target);

        const price = target?.closest?.(priceSelector);
        if (price) syncPrice(price);

        const buyPrice = target?.closest?.(buyPriceSelector);
        if (buyPrice) syncBuyPrice(buyPrice);
      });

      // StickyPrice 换变体时被整体替换, 可能不在 observerRoot 内, 这里兜底重同步
      syncStickyButtonPrices();
    });

    const observerRoot = document.querySelector('.product-form-wrapper--redesign')?.closest('product-info')
      || document.documentElement;

    observer.observe(observerRoot, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    document.addEventListener('variant:change', scheduleFormatPrices, true);
    document.addEventListener('product-price:updated', scheduleFormatPrices);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPriceFormatter, { once: true });
  } else {
    startPriceFormatter();
  }
})();
